export const DEFAULT_Y_AXIS_MAX = 10

export const DEFAULT_Y_AXIS_MIN = 0